//ドキュメント内のa要素を取得
const elements = document.getElementsByTagName('a');

for(let element of elements){
  //a要素のhref（リンク）を取得
  let target = element.getAttribute('target');

  //target属性が_blankであれば
  if(target === '_blank'){
    element.setAttribute('rel', 'noreferrer noopener');
  }
}